var _excluded = ["onPreviewImageLeft", "onPreviewImageRight", "onPreviewImageDisplayed", "onMapTypeSelect", "onMapOverlaySelect", "onMapFirstInteraction", "onCalendarDownload", "onAddToWatchlist", "onBookInspectionClick", "onPromoBoxClick", "onInspectFromHomeClick", "onGoToOnlineAuction", "onOnlineAuctionInfoClick", "onRegisterAuction", "onSignUpClick", "onLogInClick", "onRemoveFromPlannerClick", "onSuburbInfoClick", "onSummaryTabClick", "onMedianSalesTabClick", "onViewMoreInfoClick", "onUVClick", "onPropertyHistorySwipeLeft", "onPropertyHistorySwipeRight", "onPropertyHistoryTapLeft", "onPropertyHistoryTapRight", "onPropertyHistoryExpand", "onPropertyHistoryCollapse", "onPropertyHistoryPhoto", "onChildDevelopmentLinkClick", "onParentDevelopmentLinkClick"];
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == typeof i ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != typeof t || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != typeof i) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
import React from 'react';
import PropTypes from 'prop-types';
import { AnalyticsMetric, ListingType, WMSMapLayer, gaHelper } from '@domain-group/fe-allhomes-library';
import { allhomesAnalyticsEnabled } from '@domain-group/fe-co-allhomes-analytics';
import { MapType } from '@domain-group/fe-co-allhomes-listing-map';
import { GAActions, GALabels, ListingUseType } from '../analytics/constants';
import { jsx as ___EmotionJSX } from "@emotion/core";
var getListingUseType = listingType => {
  if (listingType === ListingType.SALES_BUSINESS) {
    return ListingUseType.BUSINESS;
  }
  return listingType.isCommercial ? ListingUseType.COMMERCIAL : ListingUseType.RESIDENTIAL;
};
var allhomesAnalyticsWrapper = BaseListingDetails => {
  class AllhomesAnalyticsWrapper extends React.Component {
    constructor(props) {
      var _this, _props$property$listi, _props$property$listi2;
      super(props);
      _this = this;
      _defineProperty(this, "onPreviewImageDisplayed", (index, image) => {
        this.fireListingMetric(AnalyticsMetric.PHOTO_VIEW, {
          listing_photo_id: index,
          photoUrl: image.src
        });
        this.props.onPreviewImageDisplayed(index, image);
      });
      _defineProperty(this, "onPreviewImageLeft", function () {
        gaHelper.interactionEvent(GAActions.VIEW_IMAGES, GALabels.PREVIEW_LEFT);
        _this.props.onPreviewImageLeft(...arguments);
      });
      _defineProperty(this, "onPreviewImageRight", function () {
        gaHelper.interactionEvent(GAActions.VIEW_IMAGES, GALabels.PREVIEW_RIGHT);
        _this.props.onPreviewImageRight(...arguments);
      });
      _defineProperty(this, "onMapTypeSelect", mapTypeId => {
        switch (mapTypeId) {
          case MapType.GOOGLE_ROAD_MAP.id:
            this.fireListingMetricNoData(AnalyticsMetric.MAPPING_AREA_MAP_CLICK);
            break;
          case MapType.GOOGLE_SATELLITE_MAP.id:
            this.fireListingMetricNoData(AnalyticsMetric.MAPPING_AERIAL_VIEW_CLICK);
            break;
          case MapType.STREET_VIEW.id:
            this.fireListingMetricNoData(AnalyticsMetric.MAPPING_STREET_VIEW_CLICK);
            break;
          default:
            // Do nothing
            break;
        }
        this.props.onMapTypeSelect(mapTypeId);
      });
      _defineProperty(this, "onMapOverlaySelect", layerId => {
        switch (layerId) {
          case null:
            this.fireListingMetricNoData(AnalyticsMetric.MAPPING_LAND_DETAILS_CLICK);
            break;
          case WMSMapLayer.TP_ZONES.id:
            this.fireListingMetricNoData(AnalyticsMetric.MAPPING_TERRITORY_PLANNING);
            break;
          case WMSMapLayer.EASEMENTS.id:
            this.fireListingMetricNoData(AnalyticsMetric.MAPPING_EASEMENT);
            break;
          case WMSMapLayer.UNIMPROVED_LAND_VALUES.id:
            this.fireListingMetricNoData(AnalyticsMetric.MAPPING_UNIMPROVED_LAND);
            break;
          case WMSMapLayer.CONTOURS.id:
            this.fireListingMetricNoData(AnalyticsMetric.MAPPING_CONTOURS);
            break;
          case WMSMapLayer.PRIMARY_SCHOOL.id:
          case WMSMapLayer.HIGH_SCHOOL.id:
          case WMSMapLayer.COLLEGE.id:
          case WMSMapLayer.FUTURE_PRIMARY_SCHOOL.id:
          case WMSMapLayer.FUTURE_HIGH_SCHOOL.id:
          case WMSMapLayer.FUTURE_COLLEGE.id:
            this.fireListingMetricNoData(AnalyticsMetric.MAPPING_SCHOOL_PPA);
            break;
          default:
            // Do nothing
            break;
        }
        this.props.onMapOverlaySelect(layerId);
      });
      _defineProperty(this, "onMapFirstInteraction", () => {
        gaHelper.interactionEvent(GAActions.MAP_INTERACTION, 'Property Details');
        this.props.onMapFirstInteraction();
      });
      _defineProperty(this, "onCalendarDownload", (plannerEnabled, fromModal) => {
        this.fireListingMetricNoData(AnalyticsMetric.INSPECTION_TIME_SAVED);
        switch (this.listingType) {
          case ListingType.SALES_COMMERCIAL.name:
          case ListingType.SALES_RESIDENTIAL.name:
          case ListingType.SALES_BUSINESS.name:
            gaHelper.conversionEvent("".concat(GAActions.ADD_TO_CALENDAR_PREFIX, "Buy"), this.listingUseType);
            break;
          case ListingType.RENTAL_COMMERCIAL.name:
          case ListingType.RENTAL_RESIDENTIAL.name:
            gaHelper.conversionEvent("".concat(GAActions.ADD_TO_CALENDAR_PREFIX, "Rent"), this.listingUseType);
            break;
          default:
            // do nothing
            break;
        }
        if (plannerEnabled) {
          gaHelper.conversionEvent(GAActions.INSPECTION_PLANNER, fromModal ? GALabels.ADD_TO_CALENDAR_MODAL : GALabels.ADD_TO_CALENDAR);
        }
        this.props.onCalendarDownload(plannerEnabled, fromModal);
      });
      _defineProperty(this, "onAddToWatchlist", function () {
        _this.props.onAddToWatchlist(...arguments);
      });
      _defineProperty(this, "onBookInspectionClick", () => {
        this.fireListingMetricNoData(AnalyticsMetric.BOOK_INSPECTION_CLICK);
        this.props.onBookInspectionClick();
      });
      _defineProperty(this, "fireListingMetricNoData", metric => {
        this.fireListingMetric(metric, {});
      });
      _defineProperty(this, "fireListingMetric", (metric, additionalData) => {
        this.context.ahAnalytics.fireListingMetric(this.listingId, metric.metricKey, additionalData);
      });
      _defineProperty(this, "onPromoBoxClick", () => {
        gaHelper.interactionEvent(GAActions.INSPECTION_PLANNER, GALabels.PROMO_BOX);
      });
      _defineProperty(this, "onInspectFromHomeClick", () => {
        gaHelper.interactionEvent(GAActions.INSPECTION, GALabels.INSPECT_FROM_HOME_CTA);
      });
      _defineProperty(this, "onGoToOnlineAuction", () => {
        gaHelper.interactionEvent(GAActions.AUCTION, GALabels.ONLINE_AUCTION);
        this.fireListingMetricNoData(AnalyticsMetric.GOTO_ONLINE_AUCTION);
      });
      _defineProperty(this, "onOnlineAuctionInfoClick", () => {
        gaHelper.interactionEvent(GAActions.AUCTION, GALabels.ONLINE_AUCTION_INFO);
      });
      _defineProperty(this, "onRegisterAuction", () => {
        this.fireListingMetricNoData(AnalyticsMetric.EMAIL_AGENT_CLICK);
        gaHelper.interactionEvent(GAActions.AUCTION, GALabels.AUCTION_PROMO_CTA);
      });
      _defineProperty(this, "onRemoveFromPlannerClick", () => {
        gaHelper.interactionEvent(GAActions.INSPECTION_PLANNER, GALabels.REMOVE_FROM_PLANNER);
      });
      _defineProperty(this, "onSignUpClick", () => {
        gaHelper.membershipEvent(GAActions.INSPECTION_PLANNER, GALabels.CASUAL_SIGN_UP);
      });
      _defineProperty(this, "onLogInClick", () => {
        gaHelper.membershipEvent(GAActions.INSPECTION_PLANNER, GALabels.CASUAL_LOG_IN);
      });
      _defineProperty(this, "onSuburbInfoClick", () => {
        gaHelper.interactionEvent(GAActions.SUBURB_INFORMATION, GALabels.VIEW_SUBURB_INFO);
      });
      _defineProperty(this, "onSummaryTabClick", () => {
        gaHelper.interactionEvent(GAActions.SUBURB_INFORMATION, GALabels.VIEW_SUBURB_SUMMARY);
      });
      _defineProperty(this, "onMedianSalesTabClick", () => {
        gaHelper.interactionEvent(GAActions.SUBURB_INFORMATION, GALabels.VIEW_MEDIAN_SALES);
      });
      _defineProperty(this, "onViewMoreInfoClick", () => {
        gaHelper.interactionEvent(GAActions.SUBURB_INFORMATION, GALabels.VIEW_MORE_SUBURB_INFO);
      });
      _defineProperty(this, "onUVClick", () => {
        gaHelper.interactionEvent(GAActions.SUBURB_INFORMATION, GALabels.VIEW_UV_INFO);
      });
      _defineProperty(this, "onPropertyHistorySwipeLeft", () => {
        gaHelper.interactionEvent(GAActions.PROPERTY_HISTORY, GALabels.PROPERTY_HISTORY_LEFT_SWIPE);
        this.props.onPropertyHistorySwipeLeft();
      });
      _defineProperty(this, "onPropertyHistorySwipeRight", () => {
        gaHelper.interactionEvent(GAActions.PROPERTY_HISTORY, GALabels.PROPERTY_HISTORY_RIGHT_SWIPE);
        this.props.onPropertyHistorySwipeRight();
      });
      _defineProperty(this, "onPropertyHistoryTapLeft", () => {
        gaHelper.interactionEvent(GAActions.PROPERTY_HISTORY, GALabels.PROPERTY_HISTORY_LEFT_TAP);
        this.props.onPropertyHistoryTapLeft();
      });
      _defineProperty(this, "onPropertyHistoryTapRight", () => {
        gaHelper.interactionEvent(GAActions.PROPERTY_HISTORY, GALabels.PROPERTY_HISTORY_RIGHT_TAP);
        this.props.onPropertyHistoryTapRight();
      });
      _defineProperty(this, "onPropertyHistoryExpand", () => {
        gaHelper.interactionEvent(GAActions.PROPERTY_HISTORY, GALabels.PROPERTY_HISTORY_EXPAND);
        this.props.onPropertyHistoryExpand();
      });
      _defineProperty(this, "onPropertyHistoryCollapse", () => {
        gaHelper.interactionEvent(GAActions.PROPERTY_HISTORY, GALabels.PROPERTY_HISTORY_COLLAPSE);
        this.props.onPropertyHistoryCollapse();
      });
      _defineProperty(this, "onPropertyHistoryPhoto", function () {
        gaHelper.interactionEvent(GAActions.PROPERTY_HISTORY, GALabels.PROPERTY_HISTORY_PHOTO_GALLERY);
        _this.props.onPropertyHistoryPhoto(...arguments);
      });
      _defineProperty(this, "onChildDevelopmentLinkClick", function () {
        gaHelper.interactionEvent(GAActions.DEVELOPMENT_WEBSITE_LINK, GALabels.DEVELOPMENT_WEBSITE_LINK_CHILD);
        _this.props.onChildDevelopmentLinkClick(...arguments);
      });
      _defineProperty(this, "onParentDevelopmentLinkClick", function () {
        gaHelper.interactionEvent(GAActions.DEVELOPMENT_WEBSITE_LINK, GALabels.DEVELOPMENT_WEBSITE_LINK_PARENT);
        _this.props.onParentDevelopmentLinkClick(...arguments);
      });
      this.listingType = props.property ? (_props$property$listi = props.property.listing) === null || _props$property$listi === void 0 ? void 0 : _props$property$listi.type : props.listingType;
      this.listingId = props.property ? (_props$property$listi2 = props.property.listing) === null || _props$property$listi2 === void 0 ? void 0 : _props$property$listi2.id : props.listingId;
      var listingType = ListingType[this.listingType];
      this.listingUseType = getListingUseType(listingType);
    }
    render() {
      var _this$props = this.props,
        onPreviewImageLeft = _this$props.onPreviewImageLeft,
        onPreviewImageRight = _this$props.onPreviewImageRight,
        onPreviewImageDisplayed = _this$props.onPreviewImageDisplayed,
        onMapTypeSelect = _this$props.onMapTypeSelect,
        onMapOverlaySelect = _this$props.onMapOverlaySelect,
        onMapFirstInteraction = _this$props.onMapFirstInteraction,
        onCalendarDownload = _this$props.onCalendarDownload,
        onAddToWatchlist = _this$props.onAddToWatchlist,
        onBookInspectionClick = _this$props.onBookInspectionClick,
        onPromoBoxClick = _this$props.onPromoBoxClick,
        onInspectFromHomeClick = _this$props.onInspectFromHomeClick,
        onGoToOnlineAuction = _this$props.onGoToOnlineAuction,
        onOnlineAuctionInfoClick = _this$props.onOnlineAuctionInfoClick,
        onRegisterAuction = _this$props.onRegisterAuction,
        onSignUpClick = _this$props.onSignUpClick,
        onLogInClick = _this$props.onLogInClick,
        onRemoveFromPlannerClick = _this$props.onRemoveFromPlannerClick,
        onSuburbInfoClick = _this$props.onSuburbInfoClick,
        onSummaryTabClick = _this$props.onSummaryTabClick,
        onMedianSalesTabClick = _this$props.onMedianSalesTabClick,
        onViewMoreInfoClick = _this$props.onViewMoreInfoClick,
        onUVClick = _this$props.onUVClick,
        onPropertyHistorySwipeLeft = _this$props.onPropertyHistorySwipeLeft,
        onPropertyHistorySwipeRight = _this$props.onPropertyHistorySwipeRight,
        onPropertyHistoryTapLeft = _this$props.onPropertyHistoryTapLeft,
        onPropertyHistoryTapRight = _this$props.onPropertyHistoryTapRight,
        onPropertyHistoryExpand = _this$props.onPropertyHistoryExpand,
        onPropertyHistoryCollapse = _this$props.onPropertyHistoryCollapse,
        onPropertyHistoryPhoto = _this$props.onPropertyHistoryPhoto,
        onChildDevelopmentLinkClick = _this$props.onChildDevelopmentLinkClick,
        onParentDevelopmentLinkClick = _this$props.onParentDevelopmentLinkClick,
        otherBaseListingDetailsProps = _objectWithoutProperties(_this$props, _excluded);
      var props = _objectSpread(_objectSpread({}, otherBaseListingDetailsProps), {}, {
        onPreviewImageLeft: this.onPreviewImageLeft,
        onPreviewImageRight: this.onPreviewImageRight,
        onPreviewImageDisplayed: this.onPreviewImageDisplayed,
        onMapTypeSelect: this.onMapTypeSelect,
        onMapOverlaySelect: this.onMapOverlaySelect,
        onMapFirstInteraction: this.onMapFirstInteraction,
        onCalendarDownload: this.onCalendarDownload,
        onAddToWatchlist: this.onAddToWatchlist,
        onBookInspectionClick: this.onBookInspectionClick,
        onPromoBoxClick: this.onPromoBoxClick,
        onInspectFromHomeClick: this.onInspectFromHomeClick,
        onGoToOnlineAuction: this.onGoToOnlineAuction,
        onOnlineAuctionInfoClick: this.onOnlineAuctionInfoClick,
        onRegisterAuction: this.onRegisterAuction,
        onSignUpClick: this.onSignUpClick,
        onLogInClick: this.onLogInClick,
        onRemoveFromPlannerClick: this.onRemoveFromPlannerClick,
        onSuburbInfoClick: this.onSuburbInfoClick,
        onSummaryTabClick: this.onSummaryTabClick,
        onMedianSalesTabClick: this.onMedianSalesTabClick,
        onViewMoreInfoClick: this.onViewMoreInfoClick,
        onUVClick: this.onUVClick,
        onPropertyHistorySwipeLeft: this.onPropertyHistorySwipeLeft,
        onPropertyHistorySwipeRight: this.onPropertyHistorySwipeRight,
        onPropertyHistoryTapLeft: this.onPropertyHistoryTapLeft,
        onPropertyHistoryTapRight: this.onPropertyHistoryTapRight,
        onPropertyHistoryExpand: this.onPropertyHistoryExpand,
        onPropertyHistoryCollapse: this.onPropertyHistoryCollapse,
        onPropertyHistoryPhoto: this.onPropertyHistoryPhoto,
        onChildDevelopmentLinkClick: this.onChildDevelopmentLinkClick,
        onParentDevelopmentLinkClick: this.onParentDevelopmentLinkClick
      });
      return ___EmotionJSX(BaseListingDetails, props);
    }
  }
  AllhomesAnalyticsWrapper.propTypes = {
    property: PropTypes.shape({
      listing: PropTypes.shape({
        id: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
        type: PropTypes.string,
        status: PropTypes.string
      })
    }),
    listingId: PropTypes.number,
    listingType: PropTypes.oneOf(Object.keys(ListingType)),
    status: PropTypes.string,
    onPreviewImageLeft: PropTypes.func,
    onPreviewImageRight: PropTypes.func,
    onPreviewImageDisplayed: PropTypes.func,
    onMapTypeSelect: PropTypes.func,
    onMapOverlaySelect: PropTypes.func,
    onMapFirstInteraction: PropTypes.func,
    onCalendarDownload: PropTypes.func,
    onAddToWatchlist: PropTypes.func,
    onBookInspectionClick: PropTypes.func,
    onPromoBoxClick: PropTypes.func,
    onInspectFromHomeClick: PropTypes.func,
    onGoToOnlineAuction: PropTypes.func,
    onRegisterAuction: PropTypes.func,
    onOnlineAuctionInfoClick: PropTypes.func,
    onSignUpClick: PropTypes.func,
    onLogInClick: PropTypes.func,
    onRemoveFromPlannerClick: PropTypes.func,
    onSuburbInfoClick: PropTypes.func,
    onUVClick: PropTypes.func,
    onSummaryTabClick: PropTypes.func,
    onMedianSalesTabClick: PropTypes.func,
    onViewMoreInfoClick: PropTypes.func,
    onPropertyHistorySwipeLeft: PropTypes.func,
    onPropertyHistorySwipeRight: PropTypes.func,
    onPropertyHistoryTapLeft: PropTypes.func,
    onPropertyHistoryTapRight: PropTypes.func,
    onPropertyHistoryExpand: PropTypes.func,
    onPropertyHistoryCollapse: PropTypes.func,
    onPropertyHistoryPhoto: PropTypes.func,
    onChildDevelopmentLinkClick: PropTypes.func,
    onParentDevelopmentLinkClick: PropTypes.func
  };
  AllhomesAnalyticsWrapper.defaultProps = {
    property: undefined,
    listingId: undefined,
    listingType: undefined,
    status: undefined,
    onPreviewImageLeft: () => {},
    onPreviewImageRight: () => {},
    onPreviewImageDisplayed: () => {},
    onMapTypeSelect: () => {},
    onMapOverlaySelect: () => {},
    onMapFirstInteraction: () => {},
    onCalendarDownload: () => {},
    onAddToWatchlist: () => {},
    onBookInspectionClick: () => {},
    onPromoBoxClick: () => {},
    onInspectFromHomeClick: () => {},
    onGoToOnlineAuction: () => {},
    onRegisterAuction: () => {},
    onOnlineAuctionInfoClick: () => {},
    onSignUpClick: () => {},
    onLogInClick: () => {},
    onRemoveFromPlannerClick: () => {},
    onSuburbInfoClick: () => {},
    onUVClick: () => {},
    onSummaryTabClick: () => {},
    onMedianSalesTabClick: () => {},
    onViewMoreInfoClick: () => {},
    onPropertyHistorySwipeLeft: () => {},
    onPropertyHistorySwipeRight: () => {},
    onPropertyHistoryTapLeft: () => {},
    onPropertyHistoryTapRight: () => {},
    onPropertyHistoryExpand: () => {},
    onPropertyHistoryCollapse: () => {},
    onPropertyHistoryPhoto: () => {},
    onChildDevelopmentLinkClick: () => {},
    onParentDevelopmentLinkClick: () => {}
  };
  AllhomesAnalyticsWrapper.contextTypes = {
    ahAnalytics: PropTypes.shape({
      fireMetric: PropTypes.func,
      fireListingMetric: PropTypes.func
    })
  };
  return allhomesAnalyticsEnabled(AllhomesAnalyticsWrapper);
};
export default allhomesAnalyticsWrapper;